import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link, NavLink, useLocation} from 'react-router-dom';
import {IRootState} from '../../store';
import {toggleTheme, toggleSidebar} from '../../store/themeConfigSlice';
import Dropdown from '../Dropdown';
import IconMenu from '../Icon/IconMenu';
import IconSun from '../Icon/IconSun';
import IconMoon from '../Icon/IconMoon';
import IconLaptop from '../Icon/IconLaptop';
import IconLogout from '../Icon/IconLogout';
import IconMenuDashboard from '../Icon/Menu/IconMenuDashboard';
import IconMenuDatatables from '../Icon/Menu/IconMenuDatatables';
import ConfirmationModal from "../ConfirmationModal";
import IconDesktop from "../Icon/IconDesktop";
import IconMenuUsers from "../Icon/Menu/IconMenuUsers";
import {signOut, onAuthStateChanged} from "firebase/auth";
import {auth} from "../../firebase/firebase-config";

const Header = () => {
    const location = useLocation();
    const [user, setUser] = useState(null);
    // const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
    const [isLogoutModalOpen, setLogoutModalOpen] = useState(false); // State untuk modal

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }

        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (currentUser) {
                const userData = {
                    uid: currentUser.uid,
                    displayName: currentUser.displayName,
                    email: currentUser.email,
                    photoURL: currentUser.photoURL || "/assets/images/default-avatar.png",
                };
                setUser(userData);
                localStorage.setItem("user", JSON.stringify(userData));
            } else {
                setUser(null);
                localStorage.removeItem("user");
            }
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const selector = document.querySelector('ul.horizontal-menu a[href="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
            for (let i = 0; i < all.length; i++) {
                all[0]?.classList.remove('active');
            }
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele?.classList.add('active');
                    });
                }
            }
        }
    }, [location]);


    const isRtl = useSelector((state: IRootState) => state.themeConfig.rtlClass) === 'rtl' ? true : false;

    const themeConfig = useSelector((state: IRootState) => state.themeConfig);
    const dispatch = useDispatch();



    const handleLogout = async () => {
        try {
            await signOut(auth);
            localStorage.removeItem("user");
            window.location.href = "/login";
        } catch (error) {
            console.error("Error logging out:", error);
        }
    };

    return (
        // <header className={`z-40  ${themeConfig.semidark && themeConfig.menu === 'horizontal' ? 'dark' : ''}`}>
        <header className={`z-40 bg-white dark:bg-gray-900 shadow-md ${themeConfig.semidark && themeConfig.menu === 'horizontal' ? 'dark' : ''}`}>
            <div className="shadow-sm">
                <div className="relative bg-white flex w-full items-center px-5 py-2.5 dark:bg-black">
                    <div className="horizontal-logo flex lg:hidden justify-between items-center ltr:mr-2 rtl:ml-2">

                        <Link to="/" className="main-logo flex items-center shrink-0 pr-5">
                            <img
                                className="w-8 ltr:-ml-1 rtl:-mr-1 inline"
                                // className="w-11 ltr:-ml-1 rtl:-mr-1 inline"
                                src="https://dinus.ac.id/wp-content/uploads/2023/11/LogoUdinus.png"
                                // src="/assets/images/logo.png"
                                alt="logo"
                            />
                            <h1 className="text-xl font-extrabold ml-2 flex items-center hidden md:inline">
                                <span className="text-[#031A61] dark:text-gray-200">Pain</span>
                                <span className="text-[#2795D0] ml-1">Management</span>
                            </h1>

                        </Link>

                        <button
                            type="button"
                            className="collapse-icon flex-none dark:text-[#d0d2d6] hover:text-primary dark:hover:text-primary flex lg:hidden ltr:ml-2 rtl:mr-2 p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:bg-white-light/90 dark:hover:bg-dark/60"
                            onClick={() => {
                                dispatch(toggleSidebar());
                            }}
                        >
                            <IconMenu className="w-5 h-5"/>
                        </button>
                    </div>


                    <div
                        className="sm:flex-1 ltr:sm:ml-0 ltr:ml-auto sm:rtl:mr-0 rtl:mr-auto flex items-center space-x-1.5 lg:space-x-2 rtl:space-x-reverse dark:text-[#d0d2d6]">
                        <div className="sm:ltr:mr-auto sm:rtl:ml-auto">
                        </div>
                        <div>
                            {themeConfig.theme === 'light' ? (
                                <button
                                    className={`${
                                        themeConfig.theme === 'light' && 'flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60'
                                    }`}
                                    onClick={() => {
                                        dispatch(toggleTheme('dark'));
                                    }}
                                >
                                    <IconSun/>
                                </button>
                            ) : (
                                ''
                            )}
                            {themeConfig.theme === 'dark' && (
                                <button
                                    className={`${
                                        themeConfig.theme === 'dark' && 'flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60'
                                    }`}
                                    onClick={() => {
                                        dispatch(toggleTheme('system'));
                                    }}
                                >
                                    <IconMoon/>
                                </button>
                            )}
                            {themeConfig.theme === 'system' && (
                                <button
                                    className={`${
                                        themeConfig.theme === 'system' && 'flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60'
                                    }`}
                                    onClick={() => {
                                        dispatch(toggleTheme('light'));
                                    }}
                                >
                                    <IconLaptop/>
                                </button>
                            )}
                        </div>

                        {/* User Dropdown */}
                        {user && (
                            <div className="dropdown shrink-0 flex">
                                <Dropdown
                                    offset={[0, 8]}
                                    placement="bottom-end"
                                    btnClassName="relative group block"
                                    button={
                                        <img
                                            className="w-9 h-9 rounded-full object-cover saturate-50 group-hover:saturate-100"
                                            src={user.photoURL}
                                            onError={(e) => {
                                                e.currentTarget.src = "/assets/images/default-avatar.png";
                                            }}
                                            alt="userProfile"
                                        />
                                    }
                                >
                                    <ul className="text-dark dark:text-white-dark !py-0 w-[230px] font-semibold dark:text-white-light/90">
                                        <li>
                                            <div className="flex items-center px-4 py-4">
                                                <img
                                                    className="rounded-md w-10 h-10 object-cover"
                                                    src={user.photoURL}
                                                    onError={(e) => {
                                                        e.currentTarget.src = "/assets/images/default-avatar.png";
                                                    }}
                                                    alt="userProfile"
                                                />
                                                <div className="ltr:pl-4 rtl:pr-4 truncate">
                                                    <h4 className="text-base">
                                                        {user.displayName || "User"}
                                                        <span
                                                            className="text-xs bg-success-light rounded text-success px-1 ltr:ml-2 rtl:ml-2">
                                                        Pro
                                                    </span>
                                                    </h4>
                                                    <button
                                                        type="button"
                                                        className="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white"
                                                    >
                                                        {user.email || "email@example.com"}
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="border-t border-white-light dark:border-white-light/10">
                                            <button
                                                onClick={() => setLogoutModalOpen(true)}
                                                className="text-danger !py-3 flex items-center w-full text-left"
                                            >
                                                <IconLogout
                                                    className="w-4.5 h-4.5 ltr:mr-2 rtl:ml-2 rotate-90 shrink-0"/>
                                                Sign Out
                                            </button>
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                </div>

                {/* Horizontal Menu */}
                <nav className="hidden md:flex border-b border-gray-300 dark:border-gray-700 py-2 px-5">
                    <ul className="flex space-x-4 text-black dark:text-white">
                        {[{path: '/', label: 'Dashboard', icon: <IconMenuDashboard/>},
                            {
                                path: '/syariah-interventions',
                                label: 'Syariah-Interventions',
                                icon: <IconMenuDatatables/>
                            },
                            {path: '/visits', label: 'Visits', icon: <IconDesktop/>},
                            {path: '/patients', label: 'Patients', icon: <IconMenuUsers/>},
                            {path: '/user-management', label: 'User Management', icon: <IconMenuUsers/>}].map(({
                                                                                                                   path,
                                                                                                                   label,
                                                                                                                   icon
                                                                                                               }) => (
                            <li key={path}>
                                <NavLink to={path}
                                         className={({isActive}) => `flex items-center px-4 py-2 rounded-md transition border ${isActive ? 'border-gray-400 bg-gray-200 dark:bg-gray-700' : 'border-transparent'}`}>
                                    {icon}
                                    <span className="ml-2">{label}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            {/* Modal Konfirmasi Logout */}
            <ConfirmationModal
                isOpen={isLogoutModalOpen}
                onClose={() => setLogoutModalOpen(false)}
                title="Confirm Logout"
                message="Are you sure you want to log out?"
                confirmText="Logout"
                cancelText="Cancel"
                onConfirm={handleLogout}
            />
        </header>
    );
};

export default Header;
